"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchBudget = fetchBudget;
exports.gotoNextQuestion = gotoNextQuestion;
exports.progressPercentage = progressPercentage;
exports.progressPercentageProviderForUnchangedQuestion = exports.progressPercentageProviderForChangedQuestion = void 0;
exports.resetQuestionnaire = resetQuestionnaire;
exports.watchProgressPercentage = watchProgressPercentage;
exports.watchQuestionnaire = watchQuestionnaire;
var _effects = require("redux-saga/effects");
var _questionnaireActions = require("./questionnaireActions");
var _recommendationSaga = require("../recommendation/recommendationSaga");
var _recommendationUtil = require("../../utils/recommendationUtil");
var _errorActions = require("../error/errorActions");
var _userActions = require("../user/userActions");
var _recommendationActions = require("../recommendation/recommendationActions");
var _questionnaireSelectors = require("./questionnaireSelectors");
var _questionnaireMetadataHelper = require("../../hooks/questionnaire/helpers/questionnaireMetadataHelper");
var _questionnaireUtil = require("../../utils/questionnaireUtil");
var _widgetSelectors = require("../widget/widgetSelectors");
var _errorSelectors = require("../error/errorSelectors");
var _logger = require("../../services/logger");
function* fetchBudget(action) {
  try {
    yield (0, _effects.put)({
      ...(0, _questionnaireActions.resetBudgetAndRecommendation)(),
      instanceId: action.instanceId
    });
    const hasError = yield (0, _effects.select)((0, _errorSelectors.selectHasError)(action.instanceId));
    const retryIsInProgress = yield (0, _effects.select)((0, _errorSelectors.selectIsInProgress)(action.instanceId));
    if (!hasError || retryIsInProgress) {
      var _selectedAdditionalPl;
      const data = yield (0, _recommendationSaga.fetchRecommendationApiCall)(action.instanceId);
      const categoryPriceTypes = yield (0, _effects.select)((0, _widgetSelectors.selectCategoryPriceTypes)(action.instanceId));
      const selectedAdditionalPlansNumber = yield (0, _effects.select)((0, _questionnaireSelectors.selectQuestionsSelections)(action.instanceId));
      const numOfAdditionalPlans = selectedAdditionalPlansNumber === null || selectedAdditionalPlansNumber === void 0 ? void 0 : (_selectedAdditionalPl = selectedAdditionalPlansNumber.numberOfPlans) === null || _selectedAdditionalPl === void 0 ? void 0 : _selectedAdditionalPl[0];
      const budget = (0, _recommendationUtil.getPriceRangeFromRecommendation)(data, categoryPriceTypes, numOfAdditionalPlans);
      yield (0, _effects.put)({
        ...(0, _questionnaireActions.setBudget)(budget),
        instanceId: action.instanceId
      });
      yield (0, _effects.put)({
        ...(0, _recommendationActions.setRawRecommendation)(data),
        instanceId: action.instanceId
      });
      yield (0, _effects.put)({
        type: _questionnaireActions.FETCH_BUDGET_SUCCESS,
        instanceId: action.instanceId
      });
    }
  } catch (e) {
    _logger.Logger.error({
      segments: [_logger.Logger.LOGGER_SEGMENTS.SAGAS]
    })(e);
    const currentPage = yield (0, _effects.select)((0, _errorSelectors.selectCurrentPage)(action.instanceId));
    yield (0, _effects.put)({
      ...(0, _errorActions.setApiCallError)({
        actionToRetry: action,
        pageToReturnTo: currentPage
      }),
      instanceId: action.instanceId
    });
  }
}
function gotoNextQuestion(_ref) {
  let {
    payload,
    instanceId
  } = _ref;
  return function* () {
    yield (0, _effects.put)({
      type: _userActions.SAVE_USER_SESSION,
      payload,
      instanceId: instanceId
    });
  }();
}
function resetQuestionnaire(_ref2) {
  let {
    payload,
    instanceId
  } = _ref2;
  return function* () {
    yield (0, _effects.put)({
      type: _userActions.RESET_USER_SESSION,
      payload,
      instanceId: instanceId
    });
  }();
}
function progressPercentage(_ref3) {
  let {
    isQuestionChanged,
    instanceId
  } = _ref3;
  return function* () {
    const questions = yield (0, _effects.select)((0, _questionnaireSelectors.selectQuestions)(instanceId));
    const currentQuestion = yield (0, _effects.select)((0, _questionnaireSelectors.selectCurrentQuestion)(instanceId));
    const currentQuestionIndex = yield (0, _effects.select)((0, _questionnaireSelectors.selectCurrentQuestionIndex)(instanceId));
    const currentSelections = yield (0, _effects.select)((0, _questionnaireSelectors.selectCurrentSelections)(instanceId));
    const answers = yield (0, _effects.select)((0, _questionnaireSelectors.selectQuestionnaireAnswers)(instanceId));
    const isBudgetAdjusted = yield (0, _effects.select)((0, _questionnaireSelectors.selectIsBudgetAdjusted)(instanceId));
    const skipMetadata = (0, _questionnaireUtil.isBudgetQuestion)(currentQuestion) && !isBudgetAdjusted;
    const metadata = (0, _questionnaireMetadataHelper.getQuestionnaireMetadata)(currentQuestion, currentSelections, answers, skipMetadata);
    const percentage = (0, _questionnaireUtil.getProgressPercentage)({
      questions,
      currentQuestionIndex,
      flags: metadata.flags,
      isQuestionChanged
    });
    yield (0, _effects.put)({
      type: _questionnaireActions.PROGRESS_BAR_PERCENTAGE,
      payload: {
        percentage
      },
      instanceId: instanceId
    });
  }();
}
const progressPercentageProviderForChangedQuestion = action => progressPercentage({
  isQuestionChanged: true,
  instanceId: action.instanceId
});
exports.progressPercentageProviderForChangedQuestion = progressPercentageProviderForChangedQuestion;
const progressPercentageProviderForUnchangedQuestion = action => progressPercentage({
  isQuestionChanged: false,
  instanceId: action.instanceId
});
exports.progressPercentageProviderForUnchangedQuestion = progressPercentageProviderForUnchangedQuestion;
function* watchProgressPercentage() {
  yield (0, _effects.takeEvery)(_questionnaireActions.VIEW_QUESTION, progressPercentageProviderForChangedQuestion);
  yield (0, _effects.takeEvery)(_questionnaireActions.ADD_SELECTION, progressPercentageProviderForUnchangedQuestion);
  yield (0, _effects.takeEvery)(_questionnaireActions.REPLACE_SELECTION, progressPercentageProviderForUnchangedQuestion);
  yield (0, _effects.takeEvery)(_questionnaireActions.RESET_SELECTIONS, progressPercentageProviderForUnchangedQuestion);
  yield (0, _effects.takeEvery)(_questionnaireActions.RESET_QUESTIONNAIRE, progressPercentageProviderForUnchangedQuestion);
}
function* watchQuestionnaire() {
  yield (0, _effects.takeEvery)(_questionnaireActions.GOTO_NEXT_QUESTION, gotoNextQuestion);
  yield (0, _effects.takeEvery)(_questionnaireActions.RESET_QUESTIONNAIRE, resetQuestionnaire);
  yield (0, _effects.takeEvery)(_questionnaireActions.FETCH_BUDGET, fetchBudget);
  yield watchProgressPercentage();
}